export default __webpack_public_path__ + "static/hovedbilde-c68bc35cdbce2c6b01e4783162492c6a.jpg";